import httpManager from "@/app/shared/utils/httpManager";

export async function readAllNotifications() {
  await httpManager.post(`/notifications/read-all/`);
}
